import { Button, DialogContent, Grid, List, ListItem, ListItemText, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core"
import DialogComponent from "../../../../../components/Dialog"
import { DatePicker } from "../../../../../components/DatePicker"
import { MyTimePicker } from "../../../../../components/TimePicker"
import { getTranslation } from "../../../../../heplers/translationHelper"
import { useEffect, useState } from "react"
import { Get } from "../../../../../actions"
import { format } from "../../../../../heplers/format"
import dayjs from "dayjs"
import __ from "lodash"

export const ShowCalendar=({possibleMeeting,managementCompanyName,open,onClose,onUpdate,onMarkResolved})=>{
    const [meetings,setMeetings]=useState([]);
    const [meetingDate,setMeetingDate]=useState();
    const [meetingTime,setMeetingTime]=useState();
    const [meetingDuration,setMeetingDuration]=useState();




    useEffect(()=>{
        if(possibleMeeting){
            setMeetingDate(dayjs(possibleMeeting.meetingDate).format())
            setMeetingTime(dayjs(possibleMeeting.meetingTime).format())
            setMeetingDuration(possibleMeeting.meetingDuration)
          //  Find possible meetings
          Get(
            {meetingDate:dayjs(possibleMeeting.meetingDate).format()},
            "Meeting/GetAllMeetingsByDate",
            null,
            resp=>{
                //setPossibleMeetings(resp.data)
                let arr=[...resp.data,{...possibleMeeting,managementCompanyName:managementCompanyName}]
                
                setMeetings(__.sortBy(arr,x=>x.meetingTime))
            },
            error=>{

            }
          )
        }
    },[possibleMeeting,open])

    const hasClash=(allMeetings)=>allMeetings.findIndex(x=>x!=possibleMeeting && x.meetingTime==possibleMeeting.meetingTime)>=0


   return <DialogComponent open={open} fullWidth maxWidth="md" onClose={onClose} title="Calendar">
    <DialogContent>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <DatePicker
            fullWidth
            variant="outlined"
            label={getTranslation(
              "Meeting Date",
              "Date de la réunion",
              "Datum des Treffens"
            )}
            value={meetingDate}
              onChange={(value) => {
                //setFieldValue("meetingDate", value);
                setMeetingDate(value)
              }}
            //   required
            //   error={touched.meetingDate && Boolean(errors.meetingDate)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <MyTimePicker
            fullWidth
            id="meetingTime"
            variant="inline"
            size="small"
            // id="Incorporation-Date-inline"
            label={getTranslation("Time", "Temps", "Zeit")}
            name="meetingTime"
            value={meetingTime}
            onChange={(value) => {
                //setFieldValue("meetingDate", value);
                setMeetingTime(value)
              }}
            //   onChange={(value) => {
            //     //setFieldValue("meetingTime", value);
            //     const formatedTime = moment(value).format("MM-DD-YYYY HH:mm");
            //     setFieldValue("meetingTime", formatedTime);
            //   }}
            KeyboardButtonProps={{
              "aria-label": "Meeting Time",
            }}
            InputLabelProps={{
              shrink: true,
            }}
            required
            //   error={touched.meetingTime && Boolean(errors.meetingTime)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <MyTimePicker
            fullWidth
            id="meetingDuration"
            variant="inline"
            size="small"
            // id="Incorporation-Date-inline"
            label={getTranslation("Time", "Temps", "Zeit")}
            name="meetingDuration"
            value={meetingDuration}
            onChange={(value) => {
                //setFieldValue("meetingDate", value);
                setMeetingDuration(value)
              }}
            //   onChange={(value) => {
            //     //setFieldValue("meetingTime", value);
            //     const formatedTime = moment(value).format("MM-DD-YYYY HH:mm");
            //     setFieldValue("meetingDuration", formatedTime);
            //   }}
            KeyboardButtonProps={{
              "aria-label": "Meeting Time",
            }}
            InputLabelProps={{
              shrink: true,
            }}
            required
            //   error={touched.meetingTime && Boolean(errors.meetingTime)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
            <Button onClick={()=>onUpdate(meetingDate,meetingTime,meetingDuration)} variant="contained" color="secondary">Try</Button>
            <Button onClick={()=>onMarkResolved(meetingDate,meetingTime,meetingDuration)} variant="contained" style={{marginRight:"20px", backgroundColor:"lightgreen"}}>Mark Resolved</Button>
        </Grid>
      </Grid>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Company</TableCell>
            <TableCell>Meeting Time</TableCell>
            <TableCell>Duration</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell>Members</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {meetings.map(meeting=><><TableRow>
            <TableCell style={{color:dayjs(meeting.meetingTime).hour()==dayjs(possibleMeeting?.meetingTime).hour()?"red":""}} >{meeting.managementCompanyName}</TableCell>
            <TableCell style={{color:dayjs(meeting.meetingTime).hour()==dayjs(possibleMeeting?.meetingTime).hour()?"red":""}}>{format("time",meeting.meetingTime)}</TableCell>
            <TableCell style={{color:dayjs(meeting.meetingTime).hour()==dayjs(possibleMeeting?.meetingTime).hour()?"red":""}}>{dayjs(meeting.meetingDuration).hour()} hours</TableCell>
            <TableCell style={{color:dayjs(meeting.meetingTime).hour()==dayjs(possibleMeeting?.meetingTime).hour()?"red":""}}>{meeting.subject}</TableCell>
            <TableCell style={{color:dayjs(meeting.meetingTime).hour()==dayjs(possibleMeeting?.meetingTime).hour()?"red":""}}>
                {dayjs(meeting.meetingTime).hour()==dayjs(possibleMeeting?.meetingTime).hour() ? ListMembers(meeting):null}
            </TableCell>
          </TableRow>
          </>
          )}
          
          {/* <TableRow>
            <TableCell>Company A</TableCell>
            <TableCell style={{ color: "red" }}>1:00 AM</TableCell>
            <TableCell>1 hr</TableCell>
            <TableCell style={{ color: "red" }}>
              Regular meeting monthly
            </TableCell>
            <TableCell>
              <ul>
                <li style={{ color: "red" }}>Marcel Schons</li>
                <li>Asghar khan</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Company A</TableCell>
            <TableCell style={{ color: "red" }}>1:00 AM</TableCell>
            <TableCell>1 hr</TableCell>
            <TableCell style={{ color: "red" }}>
              Adhoc meeting - Current
            </TableCell>
            <TableCell>
              <ul>
                <li style={{ color: "red" }}>Marcel Schons</li>
                <li>Ceres</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Company A</TableCell>
            <TableCell>2:00 AM</TableCell>
            <TableCell>1 hr</TableCell>
            <TableCell>ABC Meeting</TableCell>
            <TableCell></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Company A</TableCell>
            <TableCell>3:00 AM</TableCell>
            <TableCell>1 hr</TableCell>
            <TableCell>ABC Meeting 2</TableCell>
            <TableCell></TableCell>
          </TableRow> */}
        </TableBody>
      </Table>
    </DialogContent>
  </DialogComponent>
}

const ListMembers=(meeting)=>{
    console.log("jkaslhdajksdhkjsada",meeting.meetingMembers)
    return <ul>
        {meeting.meetingMembers.map(member=><li>{member.memberName?member.memberName:member.fullName}</li>)}
        
    </ul>
}